define('shared/initializer/form/adapters/mixins/Checkoutable',[
    '../../constants',
    'shared/lib/RSVP',
    'shared/remote/offer/get',
    'shared/page/wcmmode',
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/util/state/adapters/form',
    'shared/util/state/adapters/order',
    'shared/util/state',
    'shared/util/checkout/offer'
],
function  (
    constants,
    RSVP,
    getOffer,
    getWCMMode,
    FormDataDispatcher,
    formAdapter,
    orderAdapter,
    state,
    offerStateUtil
) {
    'use strict';

    var skip = {};

    function Ctor() {}

    Ctor.prototype.doPageLoad = function() {
        var me = this;

        return state.adapters.add(formAdapter)
            .then(function(){
                return state.adapters.add(orderAdapter);
            })
            .then(function(){
                var dispatcher = new FormDataDispatcher( me.$form );
                var items = {
                    'cmus':
                    {
                        sources:
                        [{
                            type: 'cmus',
                            allowUndefined: true
                        }],
                        targets:
                        [{
                            type: 'form',
                            key: constants.FIELD.CMUS
                        }]
                    },
                    'user.market':
                    {
                        sources:
                        [{
                            type: 'state'
                        }],
                        targets:
                        [{
                            type: 'form',
                            key: constants.FIELD.CREDIT_CARD_MARKET_CODE
                        },
                        {
                            type: 'form',
                            key: constants.FIELD.COUNTRY
                        },
                        {
                            type: 'form',
                            key: constants.FIELD.PURCHASEINFO_MARKETCODE
                        }]
                    },
                    'user.partner':
                    {
                        sources:
                        [{
                            type: 'state',
                            doNotWait: true
                        },
                        {
                            type: 'state',
                            key: 'session.partner_code'
                        }],
                        targets:
                        [{
                            type: 'state'
                        },
                        {
                            type: 'form',
                            key: constants.FIELD.PARTNER
                        },
                        {
                            type: 'form',
                            key: constants.FIELD.PURCHASEINFO_PARTNERCODE
                        }]
                    },
                    'user.language':
                    {
                        sources:
                        [{
                            type: 'state'
                        }],
                        targets:
                        [{
                            type: 'form',
                            key: constants.FIELD.LANGUAGE
                        }]
                    },
                    'order.couponCode':
                    {
                        sources:
                        [{
                            type: 'state',
                            doNotWait: true,
                            allowUndefined: true
                        }],
                        targets:
                        [
                        {
                            type: 'form',
                            key: constants.FIELD.CouponCode
                        },
                        {
                            type: 'form',
                            key: constants.FIELD.PURCHASEINFO_COUPONCODE
                        }]
                    }
                };
                items[constants.State.OrderOfferId] = {
                    sources:
                    [{
                        type: 'state',
                        doNotWait: true
                    }],
                    targets:
                    [{
                        type: 'form',
                        key: constants.FIELD.OFFER_ID,
                        pluralKey: constants.FIELD.OFFER_ID + 's'
                    },
                    {
                        type: 'form',
                        key: constants.FIELD.PURCHASEINFO_OFFERID,
                        pluralKey: constants.FIELD.PURCHASEINFO_OFFERID + 's'
                    },
                    {
                        publish: function(key, value) {
                            value = Array.isArray(value)?value[0]:value;
                            if (value === 0 || value === '' || value == null) {
                                return RSVP.resolve();
                            }

                            return getWCMMode()
                                .then(function(mode){
                                    if (mode === 'edit' || mode === 'edit') {
                                        return RSVP.resolve(skip);
                                    }
                                    return getOffer({
                                        id: value
                                    });
                                })
                                .then(function(offer){
                                    if (offer === skip) {
                                        return RSVP.resolve(skip);
                                    }
                                    return offerStateUtil.updateStateByOffer(offer);
                                }, function(){
                                    var skipOfferValidate;
                                    function getReject(){
                                        var err = new Error('Cannot get the offer name from offermanager API.');
                                        return RSVP.reject(err);
                                    }

                                    return RSVP.resolve()
                                        .then(function(){
                                            return state.get('persistent.debugger_checkout_offer_validation_skip');
                                        })
                                        .then(function(values){
                                            skipOfferValidate = values && values[0] && values[0].value;
                                        })
                                        .then(function(){
                                            if ( skipOfferValidate === true ) {
                                                return state.push('order.offer_name', 'Fake_Offer_Name_4_Testing');
                                            }
                                            else {
                                                return getReject();
                                            }
                                        });
                                });
                        }
                    }]
                };
                return dispatcher.dispatch(
                {
                    items: items,
                    timeout: 1000 * 60 * 60
                });
            });
    };

    return Ctor;
});
